import {createTheme, ThemeOptions} from '@mui/material';
import {hapStyles} from './hap.styles';

const advanceStyles: ThemeOptions = {
	name: 'advance',
	colors: hapStyles.colors,
	palette: {
		other: {
			planColor: '#717171',
		},
	},
};

const advanceTheme = createTheme(hapStyles, advanceStyles);

export {advanceStyles, advanceTheme};
